/**
 * Is this subtitle worth showing?
 *
 * Eleven published activities carry a subtitle that is a verbatim copy of
 * their title, so the page read "Quad Biking in Casablanca" twice, once in
 * 28px and once in 14px directly beneath (owner, 2026-09-10). The data should
 * be fixed too, but a renderer that will print the same sentence twice is a
 * defect on its own - the next duplicate would show the same way.
 *
 * Compared case-insensitively and whitespace-trimmed, per locale: a row can
 * be distinct in English and duplicated in French, and it is the rendered
 * pair that matters, not the English one.
 */
export function showsSubtitle(
  title: string | null | undefined,
  subtitle: string | null | undefined,
): boolean {
  const t = (title ?? "").trim().toLowerCase();
  const s = (subtitle ?? "").trim().toLowerCase();
  return s.length > 0 && s !== t;
}
